export default __webpack_public_path__ + "static/media/IMG_2154.44c7ae5e.JPG";